/**
 * Elle önbellek invalidation haritası. RTK Query kullanılmadığı için "hangi
 * mutasyondan sonra hangi liste tazelenecek" kararı AÇIKÇA burada yazılır.
 * Yeni bir mutasyon eklerken bu haritaya da eklenir; aksi halde veri bayat kalır.
 *
 * ANAHTAR SÖZLEŞMESİ (Blok 8 düzeltme turu — tech-lead Orta-6): anahtarlar
 * `createAsyncActions(...)` ÖN EKLERİDİR. Çağrı yerleri anahtarı elle yazmaz,
 * `actions.prefix` geçirir — böylece bir aksiyon yeniden adlandırıldığında harita
 * sessizce ayrışamaz; ayrışırsa istemcilerdeki sözleşme testi düşer.
 */
import { PANEL_COMMERCE_INVALIDATION } from './invalidation-panel-commerce';
import { FAMILY_CACHE_KEYS, FAMILY_SERVER_RENDERED, familyInvalidation, } from './invalidation-families';
export const CACHE_KEYS = {
    eventList: 'events/list',
    eventDetail: 'events/detail',
    myEvents: 'events/mine',
    attendeeList: 'attendees/list',
    attendeeManageList: 'attendees/manage',
    myAttendance: 'attendance/mine',
    badge: 'attendance/badge',
    checkInSummary: 'checkin/summary',
    analytics: 'analytics/event',
    /**
     * Etkinliğin PAKET DURUMU (Faz 4 · Story 21.3): tavan şeridi, paket ekranı
     * ve kilit yüzeyleri bu tek kayıttan beslenir. Katılımcı sayısını değiştiren
     * her organizatör mutasyonu bunu da bayatlatır — aksi halde şerit eski sayıyı
     * gösterir ve kilit kalkmış olduğu hâlde ekranda durur (CLAUDE.md md. 1c).
     */
    planEntitlement: 'plans/event',
    ticketList: 'tickets/list',
    invitationList: 'invitations/list',
    applicationList: 'applications/list',
    speakerList: 'speakers/list',
    speakerLinkList: 'account/speakerLinks',
    agendaList: 'agenda/list',
    cardList: 'cards/list',
    interestList: 'interests/mine',
    privacySettings: 'settings/privacy',
    /**
     * RIZA DEFTERİ. Defter EKLEMELİdir: her yazma yeni bir satır doğurur ve
     * geçmiş tablosu bayatlar. Sunucu zaman damgasını ve sürümü kendisi yazar,
     * istemci onu uyduramaz — yazımdan sonra defter yeniden okunur. Sunucu
     * tarafında render edilen bir yüzey DEĞİLDİR (`SERVER_RENDERED_CACHE_KEYS`
     * içinde yok); yalnız oturumlu ekranlarda okunur.
     */
    consentLedger: 'account/consents',
    organizationList: 'organizations/list',
    /**
     * KURUM MARKASI (Faz 4 · Story 23.3). Bu anahtar tek bir ekranı DEĞİL, o
     * kurumun BÜTÜN etkinliklerinin public yüzeyini bayatlatır: marka canlı
     * referanstır (karar B1), yani kurum logosu/rengi değişince ezmemiş geçmiş
     * ve gelecek tüm etkinlikler birden değişir. Tek etkinlik etiketi YETMEZ —
     * geçersizleştirme `PUBLIC_EVENTS_TAG` üzerinden TOPLU yapılır.
     */
    organizationBrand: 'organizations/brand',
    /** Kurum kredi özeti (T5 · W3/W4/W5): yayın kredi harcar, kart ve diyalog tazelenir. */
    organizationCredits: 'organizations/credits',
    /** Kurumun ekip listesi ve ondan türeyen özet (mobil TM2 ekip kartı sayıları). */
    organizationMembers: 'organizations/members',
    /** Kurum doğrulama ekranının durumu (dört durum + son başvuru). */
    organizationVerification: 'organizations/verification',
    /** Admin kurum doğrulama kuyruğu (Story 18.4). */
    adminVerificationQueue: 'admin/verifications',
    claimList: 'claims/list',
    adminUserList: 'admin/users',
    adminQueue: 'admin/queue',
    adminOverview: 'admin/overview',
    /**
     * PERSONEL HESAPLARI ve KENDİ OTURUMLARI (panel kimliği ayrımı · panel
     * personel ekranları turu). İkisi de yalnız `apps/admin` tarafından okunur;
     * ürün istemcileri bu anahtarlara hiç dokunmaz.
     */
    staffAccountList: 'staff/accounts',
    staffSessionList: 'staff/sessions',
    // Panel (satış, kurum, kredi) ve duyuru alıcısı: ayrı modüllerde, aynı anahtar uzayı.
    ...FAMILY_CACHE_KEYS,
    // --- Görüşme talebi (Faz 2 — Epic 12) ------------------------------------
    /** Gelen + gönderilen kutu ve üst gezinmedeki bekleyen sayacı. */
    meetingRequestList: 'meetings/requests',
    /** Kişi panelindeki "talep gönderebilir miyim" kapısı (kalan hak dahil). */
    meetingEligibility: 'meetings/eligibility',
    /** Ayarlar › engellenenler listesi. */
    meetingBlockList: 'meetings/blocks',
    /**
     * KİŞİSEL ajanda (ekran 10d). `agendaList` ORGANİZATÖR programıdır; ikisi
     * AYRI anahtardır (Blok 13 devir notu): biri etkinliğin oturum yönetimi,
     * diğeri kullanıcının kendi akışı.
     */
    myAgenda: 'agenda/mine',
    /** Organizatörün görüşme alanı listesi (Story 13.2). */
    meetingAreaList: 'meetings/areas',
    /**
     * Etkinlik kapsamlı KİŞİ önerisi (ana sayfa + katılımcı listesi kipi).
     * Engelleme listeden düşürür: engellenen kişi bir sonraki yenilemeye kadar
     * "Görüşme iste" düğmesiyle ekranda kalamaz (Blok 17).
     */
    personRecommendationList: 'recommendations/people',
    // --- Bildirim merkezi ----------------------------------------------------
    /**
     * Uygulama içi bildirim AKIŞI (zil menüsü + `/notifications` sayfası). İki
     * yüzey de aynı listeyi okur; okundu işaretleme ikisini birden bayatlatır.
     */
    notificationFeed: 'notifications/feed',
    /** Zil ROZETİ. Akıştan AYRI anahtardır: rozet listesiz de tazelenir (60 sn yoklama). */
    notificationUnreadCount: 'notifications/unread',
    announcementList: 'announcements/list',
};
const MEETING_AREA_WRITE_KEYS = [
    CACHE_KEYS.meetingAreaList,
    CACHE_KEYS.meetingEligibility,
    CACHE_KEYS.myAgenda,
];
/** Mutasyon ön eki → tazelenecek önbellek anahtarları. */
export const INVALIDATION_MAP = {
    // --- Etkinlik yaşam döngüsü (sihirbaz + yönetim) -------------------------
    'events/create': [CACHE_KEYS.eventList, CACHE_KEYS.myEvents],
    'events/update': [CACHE_KEYS.eventDetail, CACHE_KEYS.eventList, CACHE_KEYS.myEvents],
    'events/publish': [
        CACHE_KEYS.eventDetail,
        CACHE_KEYS.eventList,
        CACHE_KEYS.myEvents,
        CACHE_KEYS.organizationCredits,
        CACHE_KEYS.planEntitlement,
    ],
    'events/changeAccessMode': [CACHE_KEYS.eventDetail, CACHE_KEYS.eventList],
    'events/cancel': [CACHE_KEYS.eventDetail, CACHE_KEYS.eventList, CACHE_KEYS.myEvents],
    // --- Katılım (kendi tarafım) ---------------------------------------------
    // Kayıt/iptal yaka kartını da etkiler: kaydı olmayanın jetonu yoktur.
    'participation/register': [
        CACHE_KEYS.myAttendance,
        CACHE_KEYS.attendeeList,
        CACHE_KEYS.eventDetail,
        CACHE_KEYS.ticketList,
        CACHE_KEYS.badge,
    ],
    'participation/cancel': [
        CACHE_KEYS.myAttendance,
        CACHE_KEYS.attendeeList,
        CACHE_KEYS.eventDetail,
        CACHE_KEYS.ticketList,
        CACHE_KEYS.badge,
    ],
    'participation/apply': [CACHE_KEYS.applicationList, CACHE_KEYS.myAttendance],
    // --- Katılım (organizatör tarafı) ----------------------------------------
    'participation/queueDecide': [
        CACHE_KEYS.applicationList,
        CACHE_KEYS.attendeeList,
        CACHE_KEYS.attendeeManageList,
        CACHE_KEYS.eventDetail,
        CACHE_KEYS.analytics,
        CACHE_KEYS.planEntitlement,
    ],
    'participation/attendeeRemove': [
        CACHE_KEYS.attendeeManageList,
        CACHE_KEYS.attendeeList,
        CACHE_KEYS.eventDetail,
        CACHE_KEYS.ticketList,
        CACHE_KEYS.analytics,
        CACHE_KEYS.planEntitlement,
    ],
    /**
     * TEK SATIRIN BİLET TÜRÜ (Tur T3 · mobil kayıt yaprağı). `attendeesBulk`tan
     * AYRIDIR: toplu işlem paket yeteneğine bağlıdır, bu uç DEĞİLDİR
     * (`attendances.controller.ts`: `@RequirePlanCapability` yalnız `bulk`ta).
     * Kayıt SAYISI değişmediği için `planEntitlement` ve `attendeeList`
     * bayatlamaz; değişen şey türün kontenjanı ve bilet dağılımıdır.
     */
    'participation/attendeeTicket': [
        CACHE_KEYS.attendeeManageList,
        CACHE_KEYS.ticketList,
        CACHE_KEYS.analytics,
    ],
    'participation/attendeesBulk': [
        CACHE_KEYS.attendeeManageList,
        CACHE_KEYS.attendeeList,
        CACHE_KEYS.eventDetail,
        CACHE_KEYS.ticketList,
        CACHE_KEYS.analytics,
        CACHE_KEYS.planEntitlement,
    ],
    // --- Biletler (yayın sonrası düzenleme, ekran 3.8) -----------------------
    'participation/ticketCreate': [CACHE_KEYS.ticketList, CACHE_KEYS.eventDetail],
    'participation/ticketUpdate': [
        CACHE_KEYS.ticketList,
        CACHE_KEYS.eventDetail,
        CACHE_KEYS.analytics,
    ],
    'participation/ticketRemove': [CACHE_KEYS.ticketList, CACHE_KEYS.eventDetail],
    // --- Davet ve başvuru ----------------------------------------------------
    'participation/invitationsSend': [CACHE_KEYS.invitationList, CACHE_KEYS.analytics],
    'participation/invitationRevoke': [CACHE_KEYS.invitationList],
    'participation/invitationResend': [CACHE_KEYS.invitationList],
    'participation/invitationRequestNew': [CACHE_KEYS.invitationList],
    'participation/invitationAccept': [
        CACHE_KEYS.myAttendance,
        CACHE_KEYS.attendeeList,
        CACHE_KEYS.eventDetail,
        CACHE_KEYS.badge,
    ],
    'participation/invitationDecline': [CACHE_KEYS.myAttendance],
    'invitations/accept': [CACHE_KEYS.myAttendance, CACHE_KEYS.attendeeList, CACHE_KEYS.badge],
    'invitations/decline': [CACHE_KEYS.myAttendance],
    // --- Kapıda check-in (ekran 20) ------------------------------------------
    // Kapı sayacı ve organizatör listesindeki `checkedInAt` aynı anda bayatlar.
    'checkin/submit': [
        CACHE_KEYS.checkInSummary,
        CACHE_KEYS.attendeeManageList,
        CACHE_KEYS.analytics,
    ],
    'checkin/flush': [CACHE_KEYS.checkInSummary, CACHE_KEYS.attendeeManageList, CACHE_KEYS.analytics],
    // --- Program (konuşmacı + ajanda) ---------------------------------------
    'program/speakerCreate': [CACHE_KEYS.speakerList, CACHE_KEYS.eventDetail],
    'program/speakerUpdate': [CACHE_KEYS.speakerList, CACHE_KEYS.eventDetail],
    'program/speakerDelete': [CACHE_KEYS.speakerList, CACHE_KEYS.agendaList, CACHE_KEYS.eventDetail],
    'program/speakerReorder': [CACHE_KEYS.speakerList],
    'program/speakerLinkRequest': [CACHE_KEYS.speakerList],
    'program/speakerLinkRemove': [CACHE_KEYS.speakerList, CACHE_KEYS.speakerLinkList],
    'program/sessionCreate': [CACHE_KEYS.agendaList, CACHE_KEYS.eventDetail],
    'program/sessionUpdate': [CACHE_KEYS.agendaList, CACHE_KEYS.eventDetail],
    'program/sessionDelete': [CACHE_KEYS.agendaList, CACHE_KEYS.eventDetail],
    'account/speakerLinkRespond': [CACHE_KEYS.speakerLinkList, CACHE_KEYS.speakerList],
    'account/speakerLinkRemove': [CACHE_KEYS.speakerLinkList, CACHE_KEYS.speakerList],
    // --- Profil ve kartvizit -------------------------------------------------
    // Kart alanları katılımcı dizinindeki satırı BESLER (unvan/şirket/sektör):
    // kart değişince dizin de bayatlar, yoksa iki ekran ayrışır.
    'cards/save': [CACHE_KEYS.cardList, CACHE_KEYS.attendeeList],
    'cards/delete': [CACHE_KEYS.cardList, CACHE_KEYS.attendeeList],
    'profile/saveUser': [CACHE_KEYS.cardList, CACHE_KEYS.attendeeList],
    /*
     * Profil fotoğrafı KİŞİYE aittir (`users.avatar_media_id`) ve katılımcı
     * dizini satırındaki avatarı besler — `profile/saveUser` ile aynı sınıf.
     * Kart önizlemesi de aynı yüzü çizdiği için kart listesi de bayatlar.
     */
    'profile/saveAvatar': [CACHE_KEYS.cardList, CACHE_KEYS.attendeeList],
    'interests/save': [CACHE_KEYS.interestList, CACHE_KEYS.attendeeList],
    'onboarding/complete': [CACHE_KEYS.cardList, CACHE_KEYS.interestList, CACHE_KEYS.attendeeList],
    // --- Kurum (sihirbaz içi kurulum dahil) ---------------------------------
    'organizations/save': [CACHE_KEYS.organizationList, CACHE_KEYS.myEvents],
    /*
     * Kurum markası kaydı: kurum seçicideki logo/ad satırı, panelin etkinlik
     * künyesi ve HER public etkinlik sayfası + yaka kartı bayatlar.
     */
    'organizations/saveBrand': [
        CACHE_KEYS.organizationBrand,
        CACHE_KEYS.organizationList,
        CACHE_KEYS.eventDetail,
        CACHE_KEYS.badge,
    ],
    // Kurum kapağı (v3): yalnız SSR kurum sayfasında çizilir, `organizationBrand` kapsamı onu düşürür.
    'organizations/saveCover': [CACHE_KEYS.organizationBrand, CACHE_KEYS.organizationList],
    // Başvuru kurumu `pending`e taşır: hem doğrulama ekranı hem kurum seçicideki
    // durum etiketi bayatlar (sihirbazdaki yayın kilidi aynı durumdan çizilir).
    'organizations/submitVerification': [
        CACHE_KEYS.organizationVerification,
        CACHE_KEYS.organizationList,
    ],
    // Geri çekme kurumu `unverified`a döndürür: aynı iki yüzey bayatlar.
    'organizations/withdrawVerification': [
        CACHE_KEYS.organizationVerification,
        CACHE_KEYS.organizationList,
    ],
    // Belge silme kurum DURUMUNU değiştirmez; yalnız doğrulama ekranı bayatlar.
    'organizations/deleteVerificationDocument': [CACHE_KEYS.organizationVerification],
    /*
     * EKİP (K3). Devir ÇAĞIRANIN rolünü de düşürür (`owner` → `admin`): kurum
     * seçicideki yetki satırı bayatlar. Ayrılma ise üyeliği bitirir — kurum
     * seçici ve "Yönettiklerim" listesi ikisi birden bayatlar (kişi artık o
     * kurumun etkinliklerini yönetmiyor).
     */
    /*
     * ROL DEĞİŞİMİ ÇAĞIRANIN KENDİ ROLÜNÜ DE DEĞİŞTİREBİLİR (tech-lead · kurum
     * giriş yolu turu). Eski gerekçe "sahip kendi rolünü seçemez" diyordu ve
     * EKSİKTİ: `organization:member_manage` YÖNETİCİDE DE var ve yöneticinin
     * kendi satırı düzenlenebilir — kendini `viewer` yapabilir. `viewerRole`
     * artık üst gezinmeyi ve sihirbaz kapısını sürdüğü için bayat rol yanlış
     * ekran demektir.
     */
    // Rol ve devir EKİP ÖZETİNİ de bayatlatır (Tur B2): TM6'nın ayrıl/sil kapısı `soleOwner`dan açılır.
    'organizations/teamRoleChange': [CACHE_KEYS.organizationList, CACHE_KEYS.organizationMembers],
    'organizations/teamTransferOwnership': [
        CACHE_KEYS.organizationList,
        CACHE_KEYS.organizationMembers,
    ],
    'organizations/teamLeave': [CACHE_KEYS.organizationList, CACHE_KEYS.myEvents],
    // Davet ve çıkarma ekip özetini (üye / bekleyen davet sayısı) bayatlatır.
    'organizations/teamInvite': [CACHE_KEYS.organizationMembers],
    'organizations/teamRemove': [CACHE_KEYS.organizationMembers],
    // --- Hesap ve ayarlar ----------------------------------------------------
    // Silme talebi kullanıcıyı dizinden ANINDA düşürür (görünürlük koşulu).
    'account/deletionRequest': [CACHE_KEYS.attendeeList, CACHE_KEYS.privacySettings],
    'account/deletionCancel': [CACHE_KEYS.attendeeList, CACHE_KEYS.privacySettings],
    'settings/deletionRequest': [CACHE_KEYS.attendeeList, CACHE_KEYS.privacySettings],
    'settings/deletionCancel': [CACHE_KEYS.attendeeList, CACHE_KEYS.privacySettings],
    'account/privacyUpdate': [CACHE_KEYS.privacySettings, CACHE_KEYS.attendeeList],
    // Rıza defteri yazmaları: geçmiş tablosu ve anahtar durumları tazelenir.
    'account/consentRecord': [CACHE_KEYS.consentLedger],
    'settings/updatePrivacyDefaults': [CACHE_KEYS.privacySettings],
    /*
     * RIZA YAZIMI İKİ ŞEYİ BAYATLATIR: defterin kendisi ve gizlilik ekranı.
     * Katılımcı listesi rızaya bağlı DEĞİLDİR (kırmızı çizgi 2, 21.09.2026):
     * kaydolan listede görünür, `attendee_visibility` türü emeklidir.
     */
    'consents/record': [CACHE_KEYS.consentLedger, CACHE_KEYS.privacySettings],
    // --- Admin ---------------------------------------------------------------
    'admin/suspendUser': [CACHE_KEYS.adminUserList, CACHE_KEYS.adminOverview],
    'admin/unsuspendUser': [CACHE_KEYS.adminUserList, CACHE_KEYS.adminOverview],
    'admin/decideModeration': [
        CACHE_KEYS.adminQueue,
        CACHE_KEYS.adminOverview,
        CACHE_KEYS.adminUserList,
        CACHE_KEYS.eventList,
        CACHE_KEYS.eventDetail,
    ],
    'admin/runSignals': [CACHE_KEYS.adminQueue, CACHE_KEYS.adminOverview],
    // Personel yönetimi: her karar listeyi sunucudan tazeler (ikinci bir
    // yönetici aynı anda davet/askı yapmış olabilir; satır yerinde güncellenmez).
    'staffAccounts/invite': [CACHE_KEYS.staffAccountList],
    'staffAccounts/reinvite': [CACHE_KEYS.staffAccountList],
    'staffAccounts/cancelInvitation': [CACHE_KEYS.staffAccountList],
    'staffAccounts/suspend': [CACHE_KEYS.staffAccountList],
    'staffAccounts/unsuspend': [CACHE_KEYS.staffAccountList],
    // Kendi oturumları: tekil sonlandırma listeyi tazeler; toplu sonlandırma
    // oturum sınırıdır (depo sıfırlanır) ama anahtarı yine de bayatlatır.
    'staffSessions/revoke': [CACHE_KEYS.staffSessionList],
    'staffSessions/revokeAll': [CACHE_KEYS.staffSessionList],
    ...PANEL_COMMERCE_INVALIDATION,
    ...familyInvalidation(CACHE_KEYS),
    // Onay KEŞFİ AÇAR: doğrulanmış kurumun etkinlikleri keşif ve öneri
    // sorgularına girer — liste ve detay önbellekleri de bayatlar (Karar 1).
    'admin/decideOrganizationVerification': [
        CACHE_KEYS.adminVerificationQueue,
        CACHE_KEYS.organizationVerification,
        CACHE_KEYS.organizationList,
        CACHE_KEYS.eventList,
        CACHE_KEYS.eventDetail,
    ],
    // --- Sahiplenme (kullanıcı yüzeyi Blok 8-2'de kaldırıldı, admin kaldı) ---
    'claims/decide': [
        CACHE_KEYS.claimList,
        CACHE_KEYS.eventDetail,
        CACHE_KEYS.myEvents,
        CACHE_KEYS.adminQueue,
        CACHE_KEYS.adminOverview,
    ],
    'claims/requestInfo': [CACHE_KEYS.adminQueue],
    // --- Görüşme talebi (Faz 2 — Epic 12) ------------------------------------
    // Her yazma KAPIYI da bayatlatır: açık talep sayısı ve kalan hak sunucuda
    // değişir; aksi halde kişi panelindeki düğme eski gerekçeyi göstermeye devam eder.
    'meetings/send': [CACHE_KEYS.meetingRequestList, CACHE_KEYS.meetingEligibility],
    // Kabul ajandaya EKLER, iptal ajandadan DÜŞÜRÜR (Story 13.1).
    'meetings/respond': [
        CACHE_KEYS.meetingRequestList,
        CACHE_KEYS.meetingEligibility,
        CACHE_KEYS.myAgenda,
    ],
    'meetings/cancel': [
        CACHE_KEYS.meetingRequestList,
        CACHE_KEYS.meetingEligibility,
        CACHE_KEYS.myAgenda,
    ],
    // Engelleme İKİ YÖNDEKİ açık talepleri iptal eder (Blok 12) — kutu da bayatlar.
    'meetings/block': [
        CACHE_KEYS.meetingBlockList,
        CACHE_KEYS.meetingEligibility,
        CACHE_KEYS.meetingRequestList,
        CACHE_KEYS.personRecommendationList,
    ],
    'meetings/unblock': [CACHE_KEYS.meetingBlockList, CACHE_KEYS.meetingEligibility],
    // --- Ajanda ve görüşme alanları (Blok 14) --------------------------------
    // Alan yazımı talep formunun kapısını ve kabul edilmiş görüşmenin YERİNİ
    // değiştirir: silme taşır, ekleme/düzenleme otomatik yer atar (13.10.2026).
    'meetings/areaCreate': MEETING_AREA_WRITE_KEYS,
    'meetings/areaUpdate': MEETING_AREA_WRITE_KEYS,
    'meetings/areaDelete': MEETING_AREA_WRITE_KEYS,
    // --- Bildirim merkezi ----------------------------------------------------
    /*
     * TEKİL OKUNDU yalnız ROZETİ bayatlatır: uç GÜNCEL satırı döner ve saga onu
     * depoya yazar, yani liste yerinde tazelenir. `notificationFeed` buraya
     * yazılsaydı harita "tüketilmeyen anahtar" taşırdı (Blok 13 Düşük dersi).
     *
     * TOPLU OKUNDU listenin TAMAMINI değiştirir (yanıt yalnız sayı döner), o
     * yüzden iki yüzey birden bayatlar — md. 1c: nokta düşer VE rozet sıfırlanır.
     */
    'notifications/markRead': [CACHE_KEYS.notificationUnreadCount],
    'notifications/markAllRead': [CACHE_KEYS.notificationFeed, CACHE_KEYS.notificationUnreadCount],
};
/**
 * SUNUCUDA ÇİZİLEN (SSR/ISR) PUBLIC YÜZEY SINIFLANDIRMASI.
 *
 * BULGU 4 (elle test 2): konuşmacı eklendi, public etkinlik sayfasında
 * görünmedi. Harita `program/speakerCreate` için `eventDetail` DİYORDU ama
 * `programSaga` bu anahtarı HİÇ okumuyordu — Next'in veri önbelleği
 * düşürülmediği için sayfa 60 sn bayat kalıyordu.
 *
 * TİP DÜZEYİNDE TÜKENMİŞLİK (tech-lead O-8): tablo `Record<CacheKey, …>`dir —
 * `CACHE_KEYS`e yeni bir anahtar eklendiği anda DERLEME KIRILIR ve geliştirici
 * "bu yüzey sunucuda mı çiziliyor" sorusunu yanıtlamak ZORUNDA kalır. Eski hâli
 * elle yazılmış beş elemanlı bir diziydi; yeni bir sunucu yüzeyi sessizce
 * kapsam dışı kalabilir ve bulgu 4 birebir geri gelebilirdi.
 *
 * `true` = bu anahtar bayatlayınca Next'in VERİ önbelleği de düşmeli.
 */
export const SERVER_RENDERED_CACHE_KEYS = {
    /* --- Public etkinlik sayfası SSR ile çizilir: dört yüzey de oradan okunur. */
    [CACHE_KEYS.eventDetail]: true,
    [CACHE_KEYS.eventList]: true,
    [CACHE_KEYS.ticketList]: true,
    [CACHE_KEYS.speakerList]: true,
    [CACHE_KEYS.agendaList]: true,
    /* --- Aşağıdakiler YALNIZ istemcide çizilir (uygulama yüzeyi, SSR yok). --- */
    [CACHE_KEYS.myEvents]: false,
    [CACHE_KEYS.attendeeList]: false,
    [CACHE_KEYS.attendeeManageList]: false,
    [CACHE_KEYS.myAttendance]: false,
    [CACHE_KEYS.badge]: false,
    [CACHE_KEYS.checkInSummary]: false,
    [CACHE_KEYS.analytics]: false,
    [CACHE_KEYS.planEntitlement]: false,
    [CACHE_KEYS.invitationList]: false,
    [CACHE_KEYS.applicationList]: false,
    [CACHE_KEYS.speakerLinkList]: false,
    [CACHE_KEYS.cardList]: false,
    [CACHE_KEYS.interestList]: false,
    [CACHE_KEYS.privacySettings]: false,
    /* Rıza defteri yalnız oturumlu ekranlarda çizilir (Ayarlar › Rızalarım, kabuk bilgilendirmesi). */
    [CACHE_KEYS.consentLedger]: false,
    [CACHE_KEYS.organizationList]: false,
    [CACHE_KEYS.organizationCredits]: false,
    [CACHE_KEYS.organizationMembers]: false,
    /*
     * Kurum markası SSR yüzeyini bayatlatır ama KAPSAMI farklıdır (canlı referans,
     * karar B1): tek etkinlik etiketi yetmez, `allPublicEvents` gerekir. Bu yüzden
     * burada `false`tur ve kapsam kararı aşağıdaki `serverCacheScopeFor` içinde
     * AÇIKÇA verilir.
     */
    [CACHE_KEYS.organizationBrand]: false,
    [CACHE_KEYS.organizationVerification]: false,
    [CACHE_KEYS.adminVerificationQueue]: false,
    [CACHE_KEYS.claimList]: false,
    [CACHE_KEYS.adminUserList]: false,
    [CACHE_KEYS.adminQueue]: false,
    [CACHE_KEYS.adminOverview]: false,
    /* Panel personel listesi ve kendi oturumları: yalnız istemcide (Vite SPA). */
    [CACHE_KEYS.staffAccountList]: false,
    [CACHE_KEYS.staffSessionList]: false,
    ...FAMILY_SERVER_RENDERED,
    [CACHE_KEYS.meetingRequestList]: false,
    [CACHE_KEYS.meetingEligibility]: false,
    [CACHE_KEYS.meetingBlockList]: false,
    [CACHE_KEYS.myAgenda]: false,
    [CACHE_KEYS.meetingAreaList]: false,
    [CACHE_KEYS.personRecommendationList]: false,
    /* Bildirim merkezi yalnız istemcide çizilir (oturum yüzeyi, SSR yok). */
    [CACHE_KEYS.notificationFeed]: false,
    [CACHE_KEYS.notificationUnreadCount]: false,
    [CACHE_KEYS.announcementList]: false,
};
/**
 * Kapsam: `allPublicEvents` YALNIZCA kurum markasında (canlı referans, karar
 * B1 — bir kurum değişikliği ÇOK etkinliği birden etkiler); diğer her şey o
 * anki etkinlikle sınırlıdır. `null` = sunucu yüzeyi bayatlamaz.
 */
export function serverCacheScopeFor(mutation) {
    const keys = cacheKeysToInvalidate(mutation);
    if (keys.includes(CACHE_KEYS.organizationBrand))
        return 'allPublicEvents';
    return keys.some((key) => SERVER_RENDERED_CACHE_KEYS[key]) ? 'current' : null;
}
export function cacheKeysToInvalidate(mutation) {
    return INVALIDATION_MAP[mutation] ?? [];
}
/** Haritada karşılığı var mı — istemci sözleşme testleri bunu kullanır. */
export function isMappedMutation(mutation) {
    return Object.prototype.hasOwnProperty.call(INVALIDATION_MAP, mutation);
}
//# sourceMappingURL=invalidation.js.map